export const handleJobApply = (job, { isAuthenticated, navigate, setShowApplicationForm }) => {
  if (job?.external_apply_url) {
    window.open(job.external_apply_url, '_blank', 'noopener,noreferrer');
    return;
  }

  if (!isAuthenticated) {
    navigate('/login');
    return;
  }

  if (setShowApplicationForm) {
    setShowApplicationForm(true);
  }
};
